module.exports = __webpack_public_path__ + "img/my_discussion_bg.04059382.png";